import { motion } from 'framer-motion';
import './Hero.css';

const Hero = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openWhatsAppBooking = () => {
    const clinicPhone = '9779813538101';
    const message = `🦷 *APPOINTMENT REQUEST - Premier Dental Clinic*

Hi! I would like to book an appointment at Premier Dental Clinic.

📍 *Clinic:* Ram Devi Complex, Suryabinayak, Bhaktapur
⏰ *Hours:* Daily 8:00 AM - 7:00 PM

Please let me know your available slots. Thank you!`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${clinicPhone}?text=${encodedMessage}`;
    
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section className="hero" id="home">
      <div className="hero-content">
        <motion.div 
          className="hero-text"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
        >
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.5 }}
          >
            Why Premier Dental Clinic is the{' '}
            <span className="highlight">Best Dental Clinic in Bhaktapur</span>
          </motion.h1>
          
          <motion.p 
            className="hero-subtitle"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.7 }}
          >
            Experience painless, affordable, and world-class dental care with modern technology and international hygiene standards
          </motion.p>
          
          <motion.div 
            className="hero-buttons"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.9 }}
          >
            <button onClick={openWhatsAppBooking} className="btn btn-primary">
              📱 Book via WhatsApp
            </button>
            <a href="tel:+9779813538101" className="btn btn-secondary">
              Call Now
            </a>
          </motion.div>
        </motion.div>
        
        <motion.div 
          className="hero-image"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.4 }}
        >
          <img 
            src="/banner.jpg" 
            alt="Premier Dental Clinic - Best Dental Clinic in Bhaktapur"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
